import jsCookie from 'js-cookie';

const Cookies = jsCookie;

export { Cookies };
